import { render, staticRenderFns } from "./SearchBar.vue?vue&type=template&id=5d6809a6&scoped=true&"
import script from "./SearchBar.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SearchBar.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./SearchBar.vue?vue&type=style&index=0&id=5d6809a6&scoped=true&lang=scss&"
import style1 from "./SearchBar.vue?vue&type=style&index=1&id=5d6809a6&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6809a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d6809a6')) {
      api.createRecord('5d6809a6', component.options)
    } else {
      api.reload('5d6809a6', component.options)
    }
    module.hot.accept("./SearchBar.vue?vue&type=template&id=5d6809a6&scoped=true&", function () {
      api.rerender('5d6809a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/SearchBar/SearchBar.vue"
export default component.exports